import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { Body } from '../tabs/Beneficiaries/components/EditAssetForm/components/AccountEditAssetForm/AccountEditAssetForm.meta';
import { queryKeys } from '../../../../api/queryKeys';
import { useClientId } from '../../../../../_hooks/useClientId';
import { useFpId } from '../../../../hooks/useFpId';
import { queryClient } from '../../../../../../config/queryClient';

interface Params {
  body: Body;
  isSimulation: boolean;
}

const saveOtherAssets = (clientId: number) => ({ body, isSimulation }: Params) => {
  return authFetch(
    `/Consumer/AccountBeneficiariesUpdateV2/${
      isSimulation ? 'SaveSimulatedOtherAssetBeneficiariesV2' : 'SaveOtherAssetBeneficiariesV2'
    }`,
    {
      method: 'POST',
      ...httpBodyOptions({ ...body, clientId }, true),
    },
  );
};

export const useOtherAssetsMutation = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  return useMutation(saveOtherAssets(clientId), {
    async onSuccess() {
      const queryKey = queryKeys.estatePlanningExplanation(clientId, fpId);

      await queryClient.invalidateQueries(queryKey);
    },
  });
};
